import React, { Component } from 'react'
import { Sun } from './icons'

class Weather extends Component {

  state = {
    weather: null
  }

  componentDidMount() {
    fetch('https://api.openweathermap.org/data/2.5/weather?q=Gold+Coast,VIC,AU&units=metric&appid=4473b1fa17305953a04a6b52d98f20d8')
      .then(response => response.json())
      .then(data => {
        this.setState({ weather: data })
      })
  }

  render() {

    let { weather } = this.state

    return (
      <section className='weather'>
        <div className='weather__inner'>
          <div className='weather__content'>
            <Sun color='#FFFFFF' />
            <p>Gold Coast 
              { weather?.weather?.length > 0 &&
                <span>{ Math.round(weather.main.temp) }° C</span>
              }
            </p>
          </div>
        </div>
      </section>
    )
  }
}

export default Weather
